import Route from 'app/index';
import AuthProvider from 'contexts/auth';
import SnackbarProvider from 'contexts/snackbar';
import ThemeProvider from 'contexts/theme';
import { useLocaleRouting } from 'hooks/useLocaleRouting';
import { BrowserRouter } from 'react-router-dom';
import theme from 'shell/themes';

function App() {
    const { isRedirecting, basename, locale } = useLocaleRouting();
    if (isRedirecting) return null;

    return (
        <BrowserRouter basename={basename} key={locale}>
            <ThemeProvider theme={theme}>
                <SnackbarProvider>
                    <AuthProvider>
                        <Route />
                    </AuthProvider>
                </SnackbarProvider>
            </ThemeProvider>
        </BrowserRouter>
    );
}

export default App;
